/* eslint-disable react/display-name */
import React from 'react';
import style from './TextField.module.css';
import { Input } from '@mui/base';
import { cl } from 'lincd/utils/ClassNames';
export const TextField = React.forwardRef(function ({ error, className, helperText, ...props }, ref) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { ...props, ref: ref, className: cl(style.TextField, className, error && style.error) }),
        helperText && React.createElement("p", { className: style.helperText }, helperText)));
});
//# sourceMappingURL=TextField.js.map